import * as Sentry from '@sentry/react'
import { clearClarityLoggedInSessionStorage } from '@/shared/analytics/claritySession'
import { clearStoredUserSession } from '@/api/queryClient'

const AUTH_PATHS_EXCLUDED_FROM_SESSION_CLEAR = ['/v1/auth/login']

let isHandlingUnauthorized = false

function shouldClearSessionOnUnauthorized(requestUrl: string | undefined): boolean {
  if (!requestUrl) {
    return true
  }

  return !AUTH_PATHS_EXCLUDED_FROM_SESSION_CLEAR.some(path => requestUrl.includes(path))
}

export function handleUnauthorizedApiResponse(requestUrl: string | undefined): void {
  if (!shouldClearSessionOnUnauthorized(requestUrl)) {
    return
  }

  if (isHandlingUnauthorized) {
    return
  }

  isHandlingUnauthorized = true
  clearStoredUserSession()
  clearClarityLoggedInSessionStorage()
  Sentry.setUser(null)

  queueMicrotask(() => {
    isHandlingUnauthorized = false
  })
}
